<div *ngIf="interaction['isEdited']" class="text-black text-xs mb-1 ml-6">
    Edited
</div>
<div class="question group">
    <i
        class="bi bi-slash-circle cursor removeIcon"
        *ngIf="showContextLimitError"
        pTooltip="Context limit exceeded, this conversation has been removed from conversation history."
    ></i>
    <div class="ml-3 mr-3 w-full">
        <ng-container *ngIf="!isEditMode">
            <div class="relative">
                <i
                    *ngIf="!isDeepResearchChat"
                    class="bi bi-pencil-square edit-icon cursor-pointer"
                    (click)="enableEditMode()"
                    [class.visible]="showEditIcon"
                    (mouseenter)="showEditTooltip = true"
                    (mouseleave)="showEditTooltip = false"
                ></i>
                <div *ngIf="showEditTooltip && !isDeepResearchChat" class="custom-tooltip-inline">
                    Edit question
                </div>
                <ng-container
                    *ngFor="
                        let chartUrl of questionImagesURLS;
                        let idx = index
                    "
                >
                    <ng-container
                        *ngIf="questionImagesURLS[idx]?.loading === false; else loading"
                    >
                        <div class="image-container" (click)="displayModal = true">
                            <div class="image-scrollable">
                                <img [src]="questionImagesURLS[idx].imageURL" />
                            </div>
                            <a
                                [href]="questionImagesURLS[idx].imageURL"
                                class="download-btn"
                                [attr.download]="chartUrl.imageName"
                                (click)="downloadImage($event)"
                            >
                                <i class="bi bi-download p-0 m-0"></i>
                            </a>
                        </div>
                    </ng-container>
                    <ng-template #loading>
                        <div
                            class="image-loader flex justify-content-center align-items-center"
                        >
                            <p-progressSpinner
                                styleClass="w-3rem h-3rem"
                                strokeWidth="2"
                                animationDuration=".6s"
                            ></p-progressSpinner>
                        </div>
                    </ng-template>
                </ng-container>
                <p class="formatted-text pl-0" markdown>
                    {{ interaction['requestText'] }}
                </p>
            </div>
        </ng-container>

        <ng-container *ngIf="isEditMode">
            <div class="edit-container">
                <textarea
                    class="edit-textarea"
                    [(ngModel)]="editedText"
                    rows="4"
                ></textarea>
                <div class="edit-buttons">
                    <p class="edit-info-message">
                        <i class="bi bi-info-circle informationIcon"></i>
                        Editing this question will delete the conversations below it.
                    </p>
                    <button
                        class="cancel-button"
                        (click)="cancelEdit()"
                    >
                        Cancel
                    </button>
                    <button
                        class="send-button"
                        (click)="sendEditedQuestion()"
                    >
                        Send
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</div>
